import apiClient from '@/lib/api/apiClient'
import { API_ENDPOINTS } from '@/lib/api/config'
import type { AboutContentResponse } from '../types/help'

/** GET `/api/about_content` — same endpoint as Angular `help-about.component.ts`. */
export async function fetchAboutContent(): Promise<AboutContentResponse> {
  const { data } = await apiClient.get<AboutContentResponse>(
    API_ENDPOINTS.ABOUT_CONTENT,
  )
  return data
}
